import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Helper function to resolve image URLs
// Converts relative /api/uploads/... paths to full URLs
// Also converts Google Drive sharing links to direct image URLs
export const getImageUrl = (imageUrl) => {
  if (!imageUrl) return '';
  
  // Convert Google Drive sharing links to direct view links
  // Format: https://drive.google.com/file/d/FILE_ID/view -> https://drive.google.com/uc?export=view&id=FILE_ID
  if (imageUrl.includes('drive.google.com/file/d/')) {
    const match = imageUrl.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
    if (match && match[1]) {
      return `https://drive.google.com/uc?export=view&id=${match[1]}`;
    }
  }
  
  // Handle Google Drive open links
  // Format: https://drive.google.com/open?id=FILE_ID
  if (imageUrl.includes('drive.google.com/open?id=')) {
    const match = imageUrl.match(/[?&]id=([a-zA-Z0-9_-]+)/);
    if (match && match[1]) {
      return `https://drive.google.com/uc?export=view&id=${match[1]}`;
    }
  }
  
  // If it's already a full URL (not Google Drive), return as is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }
  
  // If it's a relative /api/ path, prepend the backend URL
  if (imageUrl.startsWith('/api/')) {
    return `${BACKEND_URL}${imageUrl}`;
  }
  
  // For other relative paths
  return imageUrl;
};

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token and customer phone
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('customerToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Add customer phone header for ticket/rating endpoints
  const customerData = localStorage.getItem('customerData');
  if (customerData) {
    try {
      const customer = JSON.parse(customerData);
      if (customer.phone) {
        config.headers['x-customer-phone'] = customer.phone;
      }
    } catch (e) {
      // Ignore parse errors
    }
  }
  return config;
});

export default api;